// extracted by mini-css-extract-plugin
export default {"draft-panel":"lsf-draft-panel","draft-panel__toggle":"lsf-draft-panel__toggle"};
    if(module.hot) {
      // 1732531523371
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  